import React from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter} from "react-router-dom";
import App from './App';
import reportWebVitals from './reportWebVitals';
import {createTheme, CssBaseline, ThemeProvider} from "@mui/material";
import './App.scss';

const theme = createTheme(
    {
        palette: {
            mode: 'light',
            primary: {
                main: '#57628D',
            },
            secondary: {
                main: '#E792BD',
                contrastText: '#ffffff',
            },
        }
    }
)

ReactDOM.render(
    <BrowserRouter>
      <React.StrictMode>
          <ThemeProvider theme={theme}>
              <CssBaseline />

              <App />

          </ThemeProvider>
      </React.StrictMode>
    </BrowserRouter>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
